import $ from 'jquery';
import { Swiper , Autoplay } from 'swiper';

Swiper.use([ Autoplay ]);

$('.swiper-container').each(function() {
  let $this = $(this);

  new Swiper($this.get(0), {
    loop: true,
    speed: 650,
    autoplay: {
      delay: 4500,
    },
  });
});
